<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.owner_horses") }} {{ ownerName }}</h5>
          <!-- <button class="back_btn" @click="$router.go(-1)">
            <i class="fas fa-arrow-left"></i>
            {{ $t("BUTTONS.back") }}
          </button> -->
        </div>
        <!-- <div class="title_route_wrapper">
          <base-button
            class="mt-0 pdf_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadExcel')"
            @fireClick="downloadPdf"
            :disabled="pdfDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-pdf"></i>
            </template>
          </base-button>
        </div> -->
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>

        <!-- Start:: Horse Name -->
        <template v-slot:[`item.name`]="{ item }">
          <h6 class="text-danger" v-if="!item.name">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.name }}</h6>
        </template>
        <!-- End:: Horse Name -->

        <!-- Start:: Horse Image -->
        <template v-slot:[`item.image`]="{ item }">
          <div class="table_image_wrapper" v-if="item.image">
            <img :src="item.image" :alt="item.name" class="horse_image" />
          </div>
          <h6 class="text-danger" v-else>
            {{ $t("TABLES.noData") }}
          </h6>
        </template>
        <!-- End:: Horse Image -->

        <!-- Start:: Average Rating -->
        <template v-slot:[`item.average_rating`]="{ item }">
          <div class="rating_wrapper" v-if="item.average_rating">
            <v-rating
              :value="item.average_rating"
              color="amber"
              dense
              half-increments
              readonly
              size="14"
            ></v-rating>
            <span class="rating_text">{{ item.average_rating.toFixed(1) }}</span>
          </div>
          <h6 class="text-danger" v-else>
            {{ $t("TABLES.noData") }}
          </h6>
        </template>
        <!-- End:: Average Rating -->

        <!-- Start:: Breed Type -->
        <template v-slot:[`item.breed_type`]="{ item }">
          <h6 class="text-danger" v-if="!item.breed_type">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.breed_type }}</h6>
        </template>
        <!-- End:: Breed Type -->

        <!-- Start:: Gender -->
        <template v-slot:[`item.gender`]="{ item }">
          <h6 class="text-danger" v-if="!item.gender">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.gender }}</h6>
        </template>
        <!-- End:: Gender -->

        <!-- Start:: Age -->
        <template v-slot:[`item.age`]="{ item }">
          <h6 class="text-danger" v-if="!item.age">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.age }} {{ $t("PLACEHOLDERS.years") }}</h6>
        </template>
        <!-- End:: Age -->

        <!-- Start:: Color -->
        <template v-slot:[`item.color`]="{ item }">
          <h6 class="text-danger" v-if="!item.color">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.color }}</h6>
        </template>
        <!-- End:: Color -->

        <!-- Start:: Health Status -->
        <template v-slot:[`item.health_status`]="{ item }">
          <h6 class="text-danger" v-if="!item.health_status">
            {{ $t("TABLES.noData") }}
          </h6>
          <v-chip
            v-else
            :color="getHealthStatusColor(item.health_status)"
            text-color="white"
            small
          >
            {{ item.health_status }}
          </v-chip>
        </template>
        <!-- End:: Health Status -->

        <!-- Start:: Status -->
        <template v-slot:[`item.status`]="{ item }">
          <h6 class="text-danger" v-if="!item.status">
            {{ $t("TABLES.noData") }}
          </h6>
          <v-chip
            v-else
            :color="getStatusColor(item.status)"
            text-color="white"
            small
          >
            {{ item.status }}
          </v-chip>
        </template>
        <!-- End:: Status -->

        <!-- Start:: Training Level -->
        <template v-slot:[`item.training_level`]="{ item }">
          <h6 class="text-danger" v-if="!item.training_level">
            {{ $t("TABLES.noData") }}
          </h6>
          <v-chip
            v-else
            :color="getTrainingLevelColor(item.training_level)"
            text-color="white"
            small
          >
            {{ item.training_level }}
          </v-chip>
        </template>
        <!-- End:: Training Level -->

        <!-- Start:: Price -->
        <template v-slot:[`item.price`]="{ item }">
          <h6 class="text-danger" v-if="!item.price">
            {{ $t("PLACEHOLDERS.price_not_specified") }}
          </h6>
          <h6 v-else class="price_text">
            {{ formatPrice(item.price) }} {{ $t("PLACEHOLDERS.riyal") }}
          </h6>
        </template>
        <!-- End:: Price -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OwnerHorses",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      pdfDownloadBtnIsLoading: false,
      // End:: Loading Data

      // Start:: Owner Data
      ownerName: "",
      // End:: Owner Data

      // Start:: Table Data
      tableHeaders: [
        {
          text: this.$t("TABLES.Horses.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.name"),
          value: "name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.image"),
          value: "image",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.average_rating"),
          value: "average_rating",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.breed_type"),
          value: "breed_type",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.gender"),
          value: "gender",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.age"),
          value: "age",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.color"),
          value: "color",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.health_status"),
          value: "health_status",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.status"),
          value: "status",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.training_level"),
          value: "training_level",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Horses.price"),
          value: "price",
          align: "center",
          sortable: false,
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data

      excel_link: null,
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    async downloadPdf() {
      if (this.excel_link) {
        window.location.href = this.excel_link;
      }
    },

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Data
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },

    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `owners/${this.$route.params.id}/horses`,
          params: {
            page: this.paginations.current_page,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.horses || [];
        
        // Get owner name from response if available
        if (res.data.data.owner_name) {
          this.ownerName = res.data.data.owner_name;
        }
        
        // Handle pagination if provided
        if (res.data.data.meta) {
          this.paginations.last_page = res.data.data.meta.last_page;
          this.paginations.items_per_page = res.data.data.meta.per_page;
        }
        
        if (res.data.data.export_url) {
          this.excel_link = res.data.data.export_url;
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Helper Methods for Colors
    getHealthStatusColor(status) {
      switch (status) {
        case "ممتاز":
        case "excellent":
          return "green";
        case "جيد":
        case "good":
          return "blue";
        case "متوسط":
        case "average":
          return "orange";
        case "ضعيف":
        case "poor":
          return "red";
        default:
          return "gray";
      }
    },

    getStatusColor(status) {
      switch (status) {
        case "متاح":
        case "available":
          return "green";
        case "مشغول":
        case "busy":
          return "red";
        case "قيد التدريب":
        case "training":
          return "orange";
        default:
          return "gray";
      }
    },

    getTrainingLevelColor(level) {
      switch (level) {
        case "خبير":
        case "expert":
          return "purple";
        case "متقدم":
        case "advanced":
          return "indigo";
        case "متوسط":
        case "intermediate":
          return "blue";
        case "مبتدئ":
        case "beginner":
          return "teal";
        default:
          return "gray";
      }
    },

    formatPrice(price) {
      return new Intl.NumberFormat().format(price);
    },
    // End:: Helper Methods
  },

  created() {
    // Start:: Fire Methods
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.horse_image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ddd;
}

.rating_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.rating_text {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.price_text {
  font-weight: bold;
  color: #2e7d32;
}

.back_btn {
  background-color: #f6a513;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.back_btn:hover {
  background-color: #e0950e;
}

.table_title_wrapper .title_text_wrapper {
  display: flex;
  align-items: center;
}
</style>
